import { N1coLinkService } from "./N1coLinkService";
import type {
  N1coPaymentLinkRequest,
  PaymentLinkData,
  PaymentLinkResult,
} from "../types/n1co.types";
import type { Amortization } from "../../../api/amortization.api";
import axios from "axios";

interface N1coErrorResponse {
  title?: string;
  message?: string;
  error?: string;
}

export class N1coPayService {
  public static generatePaymentDescription(amortization: Amortization): string {
    return `Pago de amortización #${
      amortization.amortizationId
    } - Fecha: ${new Date(amortization.paymentDate).toLocaleDateString(
      "es-ES"
    )}`;
  }

  public static async createPaymentLinkForAmortization(
    data: PaymentLinkData
  ): Promise<PaymentLinkResult> {
    const expirationDateTime = new Date(Date.now() + 24 * 3600e3).toISOString();

    const req: N1coPaymentLinkRequest = {
      name: `Pago de amortización #${data.amortizationId}`,
      description: data.description,
      amount: data.amount,
      expirationDateTime,
    };

    try {
      const resp = await N1coLinkService.createLink(req);
      return { success: true, paymentUrl: resp.url };
    } catch (error: unknown) {
      let errorMessage = "Error desconocido";
      let responseData: N1coErrorResponse | undefined;

      if (axios.isAxiosError(error)) {
        responseData = error.response?.data as N1coErrorResponse;
        errorMessage =
          responseData?.title || responseData?.message || error.message;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      console.error(
        "Error al crear payment link:",
        responseData || error,
        "payload:",
        req
      );

      return {
        success: false,
        error: errorMessage,
      };
    }
  }
}
